import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import { Box, Card, Stack, Tab, Tabs } from "@mui/material"
import {TabContext, TabPanel} from "@mui/lab";
import Loading from "../../components/Common/Loading";
import PaymentsCM from "../Payments/cm";
import ConsumablesCM from "../Consumables/cm";
import {stringify, parse} from "lossless-json";
import {getDeviceIdAbsentWarning} from "../../core/utils/constants";
import WarningTwoToneIcon from "@mui/icons-material/WarningTwoTone";
import InAppCM from "../Payments/InAppCM";
import TechInfoCM from "../TechInfo/techInfoCM";
import {useGetChargesScV2Query} from "../../core/api/solitaire-charge-api";
import ClanInfo from "./clanInfo";
import ClanChat from "./clanChat";
import ClanHistory from "./clanHistory";
import ClanJoin from "./clanJoin";
import ClanStatus from "./clanStatus";
import ClanSearch from "./clanSearch";


function ClansCM(props) {
    const {action, tab: tabParam, subtab: subTabParam, game} = useParams()
    const CommonData = useSelector((state) => state.data.CommonData)
    const deviceId = CommonData.deviceId
    const stateId = CommonData.stateId

    const link_prefix = '/' + game + '/' + action + '/' + deviceId + '/'
    const link_postfix = '?vendorId='+stateId

    const dispatch = useDispatch();
    const deviceIdIsEmpty = deviceId == null || deviceId == '' || typeof deviceId == 'object';

    const TABS = ['membership', 'chat', 'status', 'history', 'join'];
    const tab = TABS.includes(tabParam) ? tabParam : 'membership'

    const [tabIndex, setTabIndex] = useState(tab);

    // Без deviceId доступна только вкладка Membership (с поиском клана)
    const activeTab = deviceIdIsEmpty ? 'membership' : tabIndex;

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    const tabLinkProps = (value) => deviceIdIsEmpty
        ? {}
        : {component: Link, to: link_prefix + value + link_postfix};

    return (
        <TabContext value={activeTab}>
            <Box sx={{mb:2}}>
                <ClanSearch />
            </Box>


            <Card>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Membership" value="membership" {...tabLinkProps("membership")}/>
                    <Tab label="Chat" value="chat" disabled={deviceIdIsEmpty} {...tabLinkProps("chat")}/>
                    <Tab label="Member Status" value="status" disabled={deviceIdIsEmpty} {...tabLinkProps("status")}/>
                    <Tab label="Full history" value="history" disabled={deviceIdIsEmpty} {...tabLinkProps("history")}/>
                    <Tab label="Join" value="join" disabled={deviceIdIsEmpty} {...tabLinkProps("join")}/>
                </Tabs>
            </Card>


            <TabPanel value="membership">
                <Stack spacing={2}>
                    {deviceIdIsEmpty
                        ? <Box>{getDeviceIdAbsentWarning()}</Box>
                        : <ClanInfo userId={deviceId} />
                    }

                </Stack>
            </TabPanel>

            {!deviceIdIsEmpty && (
                <>
                    <TabPanel value="chat">
                        <ClanChat userId={deviceId} />
                    </TabPanel>

                    <TabPanel value="status">
                        <ClanStatus userId={deviceId} />
                    </TabPanel>

                    <TabPanel value="history">
                        <ClanHistory userId={deviceId} />
                    </TabPanel>

                    <TabPanel value="join">
                        <ClanJoin userId={deviceId} />
                    </TabPanel>
                </>
            )}
        </TabContext>
    );

}

export default ClansCM
